import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    name: 'zone',
    path: 'zone',
    component: () => import('#/dashboard/zone/zone.view.vue'),
    children: [
      // Draw-only exploration mode — reuses details.view with a synthetic,
      // layer-less in-memory zone (see DetailsView.setupExploreMode). Static
      // segment, so it outranks the optional-param route below for /zone/explore.
      {
        name: 'zone:explore',
        path: 'explore',
        component: () => import('#/dashboard/zone/details/details.view.vue'),
      },
      {
        name: 'zone:zone',
        path: ':multizoneId?/:zoneId?',
        component: () => import('#/dashboard/zone/details/details.view.vue'),
      },
    ],
  },
  // Legacy redirect
  {
    path: '/zones/:id',
    redirect: (to) => ({
      path: `/zone/${to.params.id}`,
    }),
  },
];
